export default __webpack_public_path__ + "static/map-91bcaf5e8ba942cf2be01c2c3ea4bef7.svg";